import { Box, CircularProgress, Tooltip, Typography } from '@mui/material';
import { FormikConfig } from 'formik';
import React from 'react';
import Details from '../../../components/Details/Details';
import FilterComponentV2 from '../../../components/TablegridWithFilters/FilterComponent/FilterComponentv2';
import { getUserDetails } from '../../../lib/fetchers';
import { eliminateOjectNotTruthyValues, matchRefsWithData } from '../../../lib/helperFuncs';
import { userDetailsAFMRefs } from '../../../lib/static/details/staticDetails';
import { userDetailsByAFMFields } from '../../../lib/static/filters/filterFields';
import { userDetailsAFMIinitialValues } from '../../../lib/static/filters/initialValues';
import { userDetailsValidationSchema } from '../../../lib/static/filters/ValidationSchema';
import Theme from '../../../Themes/main.theme';
import InfoIcon from '@mui/icons-material/Info';

const ApplicantInfo = () => {
  const [data, setData] = React.useState();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>();

  const onSubmit = async (values: FormikConfig<any>) => {
    setIsLoading(true);
    try {
      const response = await getUserDetails(eliminateOjectNotTruthyValues(values));
      setError('');
      setData(response.data);
    } catch (error: any) {
      console.error(error);
      if (error.response.status === 400) {
        setError(error.response.data.message);
      }
    }
    setIsLoading(false);
  };

  const details = matchRefsWithData(data, userDetailsAFMRefs);

  return (
    <>
      <Typography sx={{my: 2}} variant='h2'
        color={Theme?.labelColor?.main}>Στοιχεία Ηλεκτρονικού Παραβόλου</Typography>
      <FilterComponentV2
        title={
          <>
            Φίλτρα Αναζήτησης Στοιχείων Αιτούντος (Φυσικό - Μη Φυσικό Πρόσωπο)
            <Tooltip
              PopperProps={{
                disablePortal: true
              }} title={<Typography variant='subtitle2'>
                Στην περίπτωση φυσικού προσώπου επιστρέφεται ο πρώτος χαρακτήρας 
                των πεδίων lastName, firstName και fatherName. Στην περίπτωση νομικού προσώπου
                επιστρέφονται οι τρεις πρώτοι χαρακτήρες του πεδίου lastName (μόνο)
              </Typography>
              }
              placement='right-start'>
              <InfoIcon sx={{color: Theme?.iconColor?.main, ml: 1, fontSize: '20px'}}/>
            </Tooltip>
          </>
        }
        validationSchema={userDetailsValidationSchema}
        filterFields={userDetailsByAFMFields}
        initialValues={userDetailsAFMIinitialValues}
        resetFilters={true}
        changeFilters={filterValues => onSubmit(filterValues)}
        validateOnBlur={false}
      />
      <Box mt={5} >
        {isLoading
          ? <Box sx={{ display: 'flex', justifyContent: 'center'}}>
            <CircularProgress />
          </Box>
          : error
            ? <Typography variant='h4' display='flex'
              justifyContent='center'>
              {error}
            </Typography> 
            : data
              ? <Box height='100%'>
                <Details rows={details}/>
              </Box> 
              : null 
        }
      </Box>
    </>
  );
};

export default ApplicantInfo;